import angular from 'angular';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import { sanitize } from '@/shared/utils/htmlHelpers';

angular.module('cxRegistrations').component('cxResourceCrmType', {
  bindings: {
    resource: '<',
    onChange: '&',
    disabled: '<',
  },
  controller: [
    'translateListFilter',
    function(translateListFilter) {
      const ctrl = this;

      ctrl.editMode = false;
      ctrl.toggleMode = () => {
        if (ctrl.disabled) return;
        ctrl.editMode = !ctrl.editMode;
      };
      ctrl.setDisplayValue = () => {
        ctrl.displayValue = ctrl.options
          .filter(x => x.checked)
          .map(x => translateListFilter(x.key, 'crmtype'))
          .join(', ');
      };

      ctrl.$onChanges = function() {
        const {
          crmOthers = false,
          crmProspects = false,
          crmCustomers = false,
          crmOwnCompanies = false,
        } = ctrl.resource ?? {};
        ctrl.options = [
          { key: 3, checked: crmCustomers },
          { key: 4, checked: crmOwnCompanies },
          { key: 2, checked: crmProspects },
          { key: 0, checked: crmOthers },
        ];
        ctrl.setDisplayValue();
      };
      ctrl.toggleChecked = (option, e) => {
        e.stopPropagation();
        option.checked = !option.checked;
        ctrl.setDisplayValue();
      };
      ctrl.handleMenuToggle = open => {
        if (!open) {
          const data = {
            crmOthers: false,
            crmProspects: false,
            crmCustomers: false,
            crmOwnCompanies: false,
          };
          const allChecked = !ctrl.options.some(x => !x.checked);
          if (allChecked) {
            ctrl.options.forEach(e => (e.checked = false));
            ctrl.setDisplayValue();
          } else {
            ctrl.options.forEach(e => {
              switch (e.key) {
                case 0:
                  data.crmOthers = e.checked;
                  break;
                case 2:
                  data.crmProspects = e.checked;
                  break;
                case 3:
                  data.crmCustomers = e.checked;
                  break;
                case 4:
                  data.crmOwnCompanies = e.checked;
                  break;
              }
            });
          }
          ctrl.onChange({ $data: data });
        }
      };
    },
  ],
  template: `<span uib-dropdown auto-close="outsideClick" on-toggle="$ctrl.handleMenuToggle(open)">
        <a uib-dropdown-toggle id="crm-selector" ng-class="{bold:!$ctrl.disabled}">
          <span ng-bind="$ctrl.displayValue"></span>
          <span ng-show="!$ctrl.displayValue" data-translate="All"></span>
        </a>
        <ul class="dropdown-menu" uib-dropdown-menu aria-labelledby="crm-selector-dropdown">
          <li ng-repeat="option in $ctrl.options">
            <a ng-click="$ctrl.toggleChecked(option,$event)">
              <cx-checkbox value="option.checked" text="{{option.key|translateList:'crmtype'}}" on-change="$ctrl.setDisplayValue()"></cx-checkbox>
            </a>
          </li>
        </ul>
      </span>`,
});
